import { lazy } from 'react';
import { useRoutes } from 'react-router-dom';

// project-imports
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';
import Loadable from 'components/Loadable';

// render - public landing
const Landing = Loadable(lazy(() => import('pages/landing/Landing')));

// render - public legal pages
const DeveloperAgreement = Loadable(lazy(() => import('pages/legal/DeveloperAgreement')));

// ==============================|| ROUTES RENDER ||============================== //
//
// The exact "/" route (and the public legal pages) live here, as its own top-level leaf, outside every guard. It is the public
// landing page: a guest sees it, a signed-in admin sees the same page with "Open console". Nested inside
// AuthGuard's protected tree it would race that guard's own redirect to /login.

export default function ThemeRoutes() {
  return useRoutes([
    { path: '/', element: <Landing /> },
    { path: '/legal/developer-agreement', element: <DeveloperAgreement /> },
    LoginRoutes,
    MainRoutes
  ]);
}
